// import { BASE_URL } from '@/api/url';
// import BaseFuncApi from '@/api/base/commonFunc-api';
// import Enum from '@/enum/enum';
import FileClient from '@/api/file/file-client';
const fileClient = new FileClient();
export default {
    syncFolder: async function (context, payload) {
        let token = localStorage.getItem('Jwt');
        var result = await fileClient.getAsync({
            url: `${fileClient.url}/sync-folders`,
            queries: payload,
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }, true);

        if (result && result.code === 200 && result.data) {
            context.commit('updateFolders', result.data);
            return result.data;
        }
        return [];
    },

    uploadFile: async function (context, payload) {
        let token = localStorage.getItem('Jwt');
        var result = await fileClient.postAsync({
            url: `${fileClient.url}/upload`,
            data: payload,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            }
        }, true);

        if (result && result.code === 200 && result.data) {
            context.commit('updateInfoUpload', result.data);
            return result.data;
        }
        return [];
    }
}